import React from "react";
import Flip from "../../containers/FlipMatch/FlipMatch";

function Dashboard() {
    return (
        <Flip/>
    )
}

export default Dashboard;